import styled from 'styled-components';
import { Breadcrumbs } from '@veneer/core';

interface BreadcrumbsStyleProps {
  revealHeader?: boolean;
}

export const Container = styled.div`
  position: relative;
  top: -70px;
  width: 100vw;
  max-width: 100%;
  box-sizing: border-box;
  display: grid;
  padding: 0 28px;
  grid-template-columns: repeat(auto-fill, minmax(15%, 1fr));
  grid-direction: column;
  grid-auto-flow: row dense;
  gap: 16px;
  background-size: 100% 70px;
  background-repeat: no-repeat;
  > div {
    // border: 2px solid #d3d3d3;
    background-color: #ffffff;
    box-shadow: 0px 4px 24px 0px #00000014;
    border-radius: 10px !important;
  }

  .squareCardLarge {
    grid-area: span 2 / span 2;
  }

  .squareCardLargeHalf {
    grid-area: span 1 / span 2;
  }

  .squareCardSmall {
    grid-area: span 1 / span 1;
  }

  .rectangleCardLarge {
    grid-area: span 1 / span 4;
  }

  .rectangleCardSmall {
    grid-area: span 1 / span 2;
  }

  .ghost {
    border: 1px dashed #000;
    background-color: #fff;
  }

  .custom-drag-ghost {
    position: absolute;
    top: -99999px;
    left: -99999px;
    background-color: #edb458;
    border: 1px solid #e8871e;
  }

  .hidden-drag-ghost {
    opacity: 0;
  }

  .transition {
    transition: all 2s ease-out 0.5s;
    top: 0;
  }

  @media (min-width: 1920px) {
    width: calc(100% - 48px);
    max-width: 1620px;
    margin: 0 auto 28px auto;
    padding: 0;
  }
`;

export const DashBoardBreadcrumbs = styled(Breadcrumbs)<BreadcrumbsStyleProps>`
  position: relative;
  top: -85px;
  background: #fff;
  padding: clamp(10px, 1.2vw, 16px) clamp(12px, 1.6vw, 20px);
  border-radius: 4px;
  margin: 0 clamp(10px, 1.6vw, 20px);
  width: calc(100% - clamp(20px, 3.2vw, 40px));
  box-sizing: border-box;
  overflow: hidden;
  z-index: ${({ revealHeader }) => (revealHeader ? 10001 : 'auto')};
  transition: z-index 0s;

  ul,
  ol {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 4px;
    max-width: 100%;
    min-width: 0;
  }

  li {
    font-size: clamp(11px, 0.9vw, 14px) !important;
    line-height: 1.35;
    display: inline-flex;
    align-items: center;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  svg {
    width: clamp(11px, 0.9vw, 14px) !important;
    height: clamp(11px, 0.9vw, 14px) !important;
    color: #024ad8 !important;
    margin: 0 !important;
    padding-top: 1px !important;
    flex-shrink: 0;
  }

  span {
    display: inline-block;
    font-size: clamp(11px, 0.9vw, 14px) !important;
    padding: 0 clamp(2px, 0.45vw, 5px) 0 clamp(4px, 0.7vw, 10px) !important;
    color: #024ad8 !important;
    cursor: pointer !important;
    line-height: 1.35;
    max-width: 100%;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 950px) {
    ul,
    ol {
      flex-wrap: wrap;
      row-gap: 2px;
    }

    li {
      font-size: 11px !important;
    }

    span {
      font-size: 11px !important;
      padding: 0 2px 0 4px !important;
    }

    svg {
      width: 11px !important;
      height: 11px !important;
    }
  }
`;

export const BreadcrumbsLoaderContainer = styled.div<BreadcrumbsStyleProps>`
  position: relative;
  top: -85px;
  background: #fff;
  padding: clamp(10px, 1.2vw, 16px) clamp(12px, 1.6vw, 20px);
  border-radius: 4px;
  margin: 0 clamp(10px, 1.6vw, 20px);
  width: calc(100% - clamp(20px, 3.2vw, 40px));
  box-sizing: border-box;
  z-index: ${({ revealHeader }) => (revealHeader ? 10001 : 'auto')};
  transition: z-index 0s;
`;
